import React, { useState } from 'react';
import { useLogin, useNotify } from 'react-admin';
import { 
  Box, Card, CardContent, TextField, Button, Typography, CircularProgress,
  InputAdornment, IconButton
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const LoginPage = ({ redirectTo }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const login = useLogin();
  const notify = useNotify();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!username.trim()) {
      setError('请输入账号');
      notify('请输入账号', 'warning');
      return;
    }
    if (!password) {
      setError('请输入密码');
      notify('请输入密码', 'warning');
      return;
    }

    setLoading(true);
    
    try {
      await login({ username: username.trim(), password });
      notify('登录成功', 'success');
    } catch (err) {
      const errorMsg = err.message || '网络错误，请稍后重试';
      setError(errorMsg);
      notify(errorMsg, 'warning');
    } finally {
      setLoading(false);
    }
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (error) setError('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError('');
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
    >
      <Card style={{ width: 400, padding: 40, boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <CardContent>
          <Typography variant="h4" component="h1" align="center" gutterBottom style={{ fontWeight: 600, color: '#333' }}>
            两废回收后台管理
          </Typography>
          <Typography variant="body2" align="center" gutterBottom style={{ color: '#666', marginBottom: 30 }}>
            请登录您的账号
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="账号"
                value={username}
                onChange={handleUsernameChange}
                variant="outlined"
                disabled={loading}
                autoFocus
                placeholder="请输入账号"
              />
            </Box>
            
            <Box mb={2}>
              <TextField
                fullWidth
                type={showPassword ? 'text' : 'password'}
                label="密码"
                value={password}
                onChange={handlePasswordChange}
                variant="outlined"
                disabled={loading}
                placeholder="请输入密码"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            
            {error && (
              <Box mb={2} p={1} style={{ background: '#ffebee', borderRadius: 4 }}>
                <Typography style={{ color: '#c62828', fontSize: 14 }}>
                  {error}
                </Typography>
              </Box>
            )}
            
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={loading}
              style={{ height: 48, fontSize: 16, marginTop: 10 }}
            >
              {loading ? (
                <CircularProgress size={24} style={{ color: '#fff' }} />
              ) : (
                '登 录'
              )}
            </Button>
          </form>
          
 
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;